// noinspection ES6CheckImport,DuplicatedCode

import React from 'react';
import PropTypes from 'prop-types';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Typography from '@material-ui/core/Typography';
import Table from '@/modules/common/components/Table';
import TableContainer from '@/modules/common/components/TableContainer';
import { formatDate } from '~/common';
import TableHead from './TableHead';

function getCount(key, day, data) {
    return data[key][formatDate(day, 'yyyy-MM-dd')];
}

function getTotalCount(day, report) {
    let totalCount = 0;
    Object.keys(report).forEach((key) => {
        let count = report[key][formatDate(day, 'yyyy-MM-dd')];
        if (count) {
            totalCount += count;
        }
    });
    return totalCount;
}

const Component = (props) => {
    // noinspection JSUnresolvedVariable
    return (
        <TableContainer className="table-container-right" responsive={true}>
            <Table>
                <TableHead {...props}/>
                <TableBody>
                    {Object.keys(props.report).map((key, id) => (
                        <TableRow key={id}>
                            {props.days.map((day, id) => {
                                const count = getCount(key, day, props.report);
                                return (count)
                                    ? <TableCell key={id}><Typography align="right">{count}</Typography></TableCell>
                                    : <TableCell key={id}><Typography align="center">-</Typography></TableCell>;
                            })}
                        </TableRow>
                    ))}
                    <TableRow className="row-total-count">
                        {props.days.map((day, id) => (
                            <TableCell key={id} className="total-count">
                                <Typography align="right">{getTotalCount(day, props.report)}</Typography>
                            </TableCell>
                        ))}
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
};

Component.propTypes = {
    days: PropTypes.array.isRequired,
    report: PropTypes.object.isRequired,
};

let MemoizedComponent = React.memo(Component, (prevProps, nextProps) => {
    // noinspection JSUnresolvedVariable
    let prevReport = Object.keys(prevProps.report);
    // noinspection JSUnresolvedVariable
    let nextReport = Object.keys(nextProps.report);

    if (prevReport.length) {
        let equal = prevReport.every((key, index) => nextReport[index] === key);
        if (!equal) {
            return false;
        }
    }
    return true;
});

export default MemoizedComponent;
